import React from "react";
import { PROFILE } from "../lib/content";
import { Linkedin, Facebook, MessageCircle, Mail, ArrowUp, FileText } from "lucide-react";

const Footer = () => {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="bg-ink text-alabaster">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div className="font-display text-3xl font-bold tracking-tight text-terracotta-soft">
              Yazid M. Al-Badarin
            </div>
            <p className="mt-5 text-sm leading-relaxed text-alabaster/70 max-w-md">
              Tech innovator · AI educator · Patent holder. Building learning, slowly, deliberately, in service of the next generation.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a data-testid="footer-social-linkedin" href={PROFILE.linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-alabaster/25 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors" aria-label="LinkedIn"><Linkedin size={15} /></a>
              <a data-testid="footer-social-facebook" href={PROFILE.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-alabaster/25 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors" aria-label="Facebook"><Facebook size={15} /></a>
              <a data-testid="footer-social-whatsapp" href={PROFILE.whatsapp1Link} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-alabaster/25 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors" aria-label="WhatsApp"><MessageCircle size={15} /></a>
              <a data-testid="footer-social-email" href={`mailto:${PROFILE.email}`} className="w-10 h-10 rounded-full border border-alabaster/25 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors" aria-label="Email"><Mail size={15} /></a>
              <a data-testid="footer-social-researchgate" href={PROFILE.researchgate} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-alabaster/25 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors font-display font-bold text-[13px] tracking-tight" aria-label="ResearchGate">R<sup className="text-[9px] -ml-0.5">G</sup></a>
              <a data-testid="footer-social-cv" href={PROFILE.cv} target="_blank" rel="noreferrer" download className="w-10 h-10 rounded-full border border-alabaster/25 flex items-center justify-center hover:bg-terracotta hover:border-terracotta transition-colors" aria-label="Download CV"><FileText size={15} /></a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow !text-terracotta-soft mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-alabaster/80">
              <li><a className="link-underline" href={`mailto:${PROFILE.email}`}>{PROFILE.email}</a></li>
              <li><a className="link-underline" href={PROFILE.whatsapp1Link} target="_blank" rel="noreferrer">{PROFILE.whatsapp1}</a></li>
              <li><a className="link-underline" href={PROFILE.whatsapp2Link} target="_blank" rel="noreferrer">{PROFILE.whatsapp2}</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow !text-terracotta-soft mb-4">Elsewhere</div>
            <ul className="space-y-3 text-sm text-alabaster/80">
              <li><a className="link-underline" href={PROFILE.linkedin} target="_blank" rel="noreferrer">LinkedIn</a></li>
              <li><a className="link-underline" href={PROFILE.uef} target="_blank" rel="noreferrer">UEF Learning Analytics</a></li>
              <li><a className="link-underline" href={PROFILE.facebook} target="_blank" rel="noreferrer">Facebook</a></li>
            </ul>
          </div>

          <div className="md:col-span-1 flex md:justify-end">
            <button
              data-testid="footer-back-to-top"
              onClick={toTop}
              className="w-12 h-12 rounded-full bg-terracotta hover:bg-terracotta-hover text-alabaster flex items-center justify-center transition-colors"
              aria-label="Back to top"
            >
              <ArrowUp size={18} />
            </button>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-alabaster/15 flex flex-col sm:flex-row gap-3 justify-between text-xs text-alabaster/60">
          <span>© {new Date().getFullYear()} Yazid M. Al-Badarin. All rights reserved.</span>
          <span className="tracking-widest uppercase font-display font-semibold">Shaping the Future</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
